import classNames from './MoveStudentsPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import Button from '@/components/school-management/Button/Button';
import { MoveClassDestination } from '@/school-management/types/services/bulk';

interface AvailableSeatsProps {
  students: StudentReportItem[];
  classDestination: MoveClassDestination;
  moveSource: string;
  onBack: () => void;
}

const AvailableSeats = ({
  students,
  classDestination,
  moveSource,
  onBack,
}: AvailableSeatsProps) => {
  const { t } = useAdminTranslation();

  return (
    <>
      <div>
        <div className={classNames.title} style={{ maxWidth: '455px' }}>
          {t('bulkActions.moveStudents.availableSeats.title')}
        </div>
        <div className={classNames.description} style={{ maxWidth: '455px' }}>
          {t('bulkActions.moveStudents.availableSeats.description', {
            selectedCount: (students || []).filter(s => {
              if (s.groupId === classDestination.groupId) {
                return false;
              }

              if (moveSource === 'DifferentGradeSame' && s.gradeId !== classDestination.gradeId) {
                return false;
              }

              return true;
            }).length,
            availableSeats: classDestination.remainingCapacity,
            destinationClass: classDestination.groupName,
          })}
        </div>
      </div>
      <div className={classNames.footer}>
        <Button className={classNames.button} onClick={onBack}>
          {t('common.back')}
        </Button>
      </div>
    </>
  );
};

export default AvailableSeats;
